/**
 * Builds a short human-readable detail string from Orderful's validation and
 * delivery statuses for an outbound EDI transaction. Used as a tooltip on the
 * status chips in the Famous shipment (856) and invoice (810/880) tables so
 * users can see *why* a transaction is pending or failed without leaving the
 * page. Returns '' when neither status is known (older rows) — MUI Tooltip
 * renders nothing for an empty title.
 */
export function formatEdiStatusDetail(
  validationStatus: string | null | undefined,
  deliveryStatus: string | null | undefined,
): string {
  const parts: string[] = [];
  if (validationStatus) parts.push(`Validation: ${validationStatus}`);
  if (deliveryStatus) parts.push(`Delivery: ${deliveryStatus}`);
  return parts.join(' • ');
}
